import { Modal, Container } from "react-bootstrap";

function ResetModal(props) {
  return (
    <div>
      <Modal show={props.show} onHide={props.onHide} size={props.size} centered>
        <Modal.Body>
          <label
            style={{
              fontSize: "30px",
              fontFamily: "Made-Tommy-Soft-Medium",
              color: "var(--gray)",
            }}
          >
            {" "}
            RESET {props.title}{" "}
          </label>
          <div className="col-sm-12">
            <hr />
            <Container fluid className="modal-cont justify-content-center">
              {props.children}
            </Container>

            <div className="col-sm-12 mt-3 d-flex justify-content-end">
              <button className="button-secondary me-3" onClick={props.onHide}>
                Cancel
              </button>
              <button className="button-primary" onClick={props.onSave}>
                Reset
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

ResetModal.defaultProps = {
  title: "",
  // type:"",
  size: "xl",
  show: () => {},
  onHide: () => {},
  onSave: () => {},
};

export default ResetModal;
